import { WAITING_DAYS_DONUT_LABEL } from './to-waiting-days-donut-chart';

export type WaitingDaysBucketLabel = (typeof WAITING_DAYS_DONUT_LABEL)[keyof typeof WAITING_DAYS_DONUT_LABEL];

export interface WaitingDaysTimingQueryParams {
    after?: string;
    before?: string;
}

const daysAgoIso = (days: number, now: Date): string => {
    const date = new Date(now);
    date.setUTCDate(date.getUTCDate() - days);
    return date.toISOString();
};

/**
 * Maps a waiting-days chart bucket to list `after`/`before` timing filters.
 * Waiting &lt;1 day started within the last day; 1–3 days started 1–3 days ago; &gt;3 days started more than 3 days ago.
 */
export const waitingDaysBucketToTimingQueryParams = (bucket: string, now: Date = new Date()): WaitingDaysTimingQueryParams => {
    switch (bucket) {
        case WAITING_DAYS_DONUT_LABEL.LESS_THAN_ONE_DAY:
            return { after: daysAgoIso(1, now) };
        case WAITING_DAYS_DONUT_LABEL.ONE_TO_THREE_DAYS:
            return { after: daysAgoIso(3, now), before: daysAgoIso(1, now) };
        case WAITING_DAYS_DONUT_LABEL.MORE_THAN_THREE_DAYS:
            return { before: daysAgoIso(3, now) };
        default:
            return {};
    }
};

export const appendTimingQueryParams = (baseUrl: string, params: WaitingDaysTimingQueryParams): string => {
    const queryIndex = baseUrl.indexOf('?');
    const path = queryIndex === -1 ? baseUrl : baseUrl.slice(0, queryIndex);
    const existing = queryIndex === -1 ? '' : baseUrl.slice(queryIndex + 1);
    const search = new URLSearchParams(existing);
    if (params.after) {
        search.set('after', params.after);
    }
    if (params.before) {
        search.set('before', params.before);
    }
    const query = search.toString();
    return query ? `${path}?${query}` : path;
};
